import { render } from "./ViewDocuments.vue?vue&type=template&id=292e10c8"
import script from "./ViewDocuments.vue?vue&type=script&lang=js"
export * from "./ViewDocuments.vue?vue&type=script&lang=js"
script.render = render

export default script